import useGetApi from 'src/api/useGetApi';
import { GetDivisionResponse } from 'src/types/application/Division';

const useDivision = (divisionId: string, enabled?: boolean) => {
  return useGetApi<GetDivisionResponse>({
    endpoint: `organization/divisions/${divisionId}`,
    options: {
      enabled: enabled && !!divisionId,
    },
  });
};

export default useDivision;
